import hr from "date-fns/locale/hr"

export const VIEW_MODE = 'VIEW'
export const EDIT_MODE = 'EDIT_MODE'
export const ADD_MODE = 'ADD'
export const ADD_PARAM = 'add'

export const MAX_LENGTH = 255;

export const APPLICANT_MODE = 'PUBLIC'

export const DATE_FORMAT = 'MM/DD/YYYY'
export const DATETIME_FORMAT = 'MM/DD/YYYY HH:mm:ss'
export const DATE_TIME_12H_FORMAT = 'MM/DD/YYYY h:mm A';
export const TIME_12H_FORMAT = 'h:mm A';
export const DURATION_FORMAT = 'HH:mm';
export const EXPORT_DATE_FORMAT = 'YYYY-MM-DD'
export const HOLIDAY_DATE_FORMAT = 'YYYY-MM-DD'
export const SCHEDULE_DATE_FORMAT = 'MMMM D, YYYY h:mm A'
export const APPLICATION_DATE_FORMAT = 'MMMM D, YYYY'
export const DEFAULT_DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
export const DEFAULT_DATE_TIME_EMPTY = '0001-01-01T00:00:00';
export const DEFAULT_DATE_TIME = '1753-01-01T00:00:00';

export const TYPE_OBJECT = 'object'
export const EXPORT_FILE_EXTENSION_FORMAT = '.xlsx'

export const APPLICANT_STATUS_PENDING = 'Pending'
export const APPLICANT_STATUS_ON_HOLD = 'On-hold'
export const APPLICANT_STATUS_REJECTED_OR_FAILED = 'Rejected/Failed'
export const APPLICANT_STATUS_SHORTLISTED = 'Shortlisted'
export const APPLICANT_STATUS_SCREENING = 'For Screening'
export const APPLICANT_STATUS_PRELIMINARY_INTERVIEW = 'For Preliminary Interview'
export const APPLICANT_STATUS_TECHNICAL_INTERVIEW = 'For Technical Interview'
export const APPLICANT_STATUS_TECHNICAL_EXAM = 'For Technical Exam'
export const APPLICANT_STATUS_FINAL_INTERVIEW = 'For Final Interview'
export const APPLICANT_STATUS_BACKGROUND_CHECK = 'Undergoing Background Check'
export const APPLICANT_STATUS_JOB_OFFER = 'Undergoing Job Offer'
export const APPLICANT_STATUS_ACCEPTED = 'Accepted'
export const APPLICANT_STATUS_EMPLOYED = 'Employed'

export const APPLICANT_STATUS_SCREENING_ID = 4
export const APPLICANT_STATUS_SHORTLISTED_ID = 3
export const APPLICANT_STATUS_REJECTED_OR_FAILED_ID = 2

export const JOB_SOURCE_OTHER = 17;
export const JOB_SOURCE_REFERRAL = 29;

export const JOB_OFFER_ACCEPTED = 'Accepted'
export const JOB_OFFER_DECLINED = 'Declined'
export const JOB_OFFER_FOR_APPROVAL = 'For Approval'

export const ONBOARDING_STATUS_PENDING_ID = 89
export const ONBOARDING_STATUS_ONGOING = 'Ongoing'
export const ONBOARDING_STATUS_DONE = 'Done'
export const PARTICIPANT_STATUS_DONE = 'Done'
export const PARTICIPANT_STATUS_PENDING = 'Pending'
export const PARTICIPANT_STATUS_PRESENT = 'Present'
export const PARTICIPANT_STATUS_ABSENT = 'Absent'
export const TRAINING_STATUS_ATTENDED = 'Attended'
export const TRAINING_STATUS_ABSENT = 'Absent'
export const TRAINING_STATUS_COMPLETED = 'Completed'
export const TRAINING_STATUS_INCOMPLETE = 'Incomplete'

export const ONLINE = "Online"
export const FACE_TO_FACE = "Face To Face"
export const COMPANY_ADDRESS = '14th Floor, BuildComm Center, Sumilon Road, Road City, 6000 Cebu'
export const PREVIEW_TITLE = 'Resume Preview';

export const INVALID_ID = 0;
export const EMPTY_STRING = '';
export const INVALID_DATE = null;
export const UNDEFINED = undefined;
export const NULL_VALUE = null;
export const NO_FILE = 'No File Chosen';
export const TARGET = 'target';

export const PDF_FILE_FORMAT = '.pdf';
export const PDF_FILE_TYPE = 'application/pdf';
export const ALT_NAME = 'Preview';

export const ERF_APPROVED_NUM = 18;
export const ERF_CANCELLED_NUM = 19;
export const ERF_PENDING_NUM = 20;
export const ERF_REJECTED_NUM = 21;

export const ERF_CREATE_FAILED_MESSAGE_1 = "Cannot File for another request as you already have a Pending Request for this Job Type";
export const ERF_CREATE_FAILED_MESSAGE_2 = "Creation failed: Please configure the approvers before proceeding.";

export const INTERVIEW_SKIP_INTERVIEW_STAGE = 'skipInterviewStage';
export const INTERVIEW_SKIP_TECHNICAL_INTERVIEW_LABEL = 'Skip Technical Interview';
export const INTERVIEW_SKIP_TECHNICAL_EXAM_LABEL = 'Skip Technical Exam';
export const INTERVIEW_RESULT_PENDING = "Pending";
export const INTERVIEW_RESULT_PASSED = "Passed";
export const INTERVIEW_RESULT_FAILED = "Failed";
export const INTERVIEW_TYPE_FACE_TO_FACE = 9;
export const INTERVIEW_TYPE_ONLINE = 10;
export const INTERVIEW_RESULT_PENDING_NUM = 23;
export const INTERVIEW_RESULT_PASSED_NUM = 24;
export const INTERVIEW_RESULT_FAILED_NUM = 25;

export const APPLICANT_STATUS_REJECTED_OR_FAILED_NUM = 2;
export const APPLICANT_STATUS_BACKGROUND_CHECK_PASS_NUM = 16;
export const APPLICANT_STATUS_BACKGROUND_CHECK_COMPLETE = 'Completed Background Check';
export const BACKGROUND_CHECK_PENDING_NUM = 21;

export const SAVE_TITLE = "Confirm Save";
export const SAVE = "Are you sure you want to save the changes?";
export const SUBMIT_TITLE = "Confirm Submit";
export const SUBMIT = "Are you sure you want to submit the record?";
export const PROCEED = "Please check the box below to proceed.";

export const NO_CHANGES_TITLE = "No Changes";
export const NO_CHANGES_CONTENT = "There are no changes to save.";
export const NO_TRAINING_CATEGORY = "NO TRAINING CATEGORY";
export const NO_TRAINING = "NO TRAININGS";
export const CONFIRM_LABEL = "Ok";
export const SAVE_CHANGES = "Save Changes";
export const CREATE_SUCCESS_TITLE = "Create Success";
export const CREATE_FAILED_TITLE = "Create Failed";
export const UPDATE_SUCCESS_TITLE = "Update Success";
export const UPDATE_FAILED_TITLE = "Update Failed";
export const INTERVIEWS_UPDATED_MESSAGE = "Interviews successfully updated.";
export const ERROR_TITLE = "Error";
export const ERROR_EMAIL_PREVIEW_MESSAGE = "Failed to load email preview";
export const SEND_SURVEY_TITLE = "Send Survey Link Email Notification";
export const SAVE_CHANGES_TO_BACKGROUND_CHECK_MESSAGE = "Save Changes to Background Check?";
export const SEND_EMAIL_NOTIFICATION_TO_CHARACTER_REFERENCES_MESSAGE = "Do you want to send email notification to Character References?";
export const FAILED_TO_SAVE_BACKGROUND_CHECK_TITLE = "Background Check Failed";
export const FAILED_TO_SAVE_BACKGROUND_CHECK_MESSAGE = "Failed to save background check";
export const SEND_SURVEY_LINK_EMAIL_NOTIFICATION_FAILED_TITLE = "Send Survey Link Email Notification Failed";
export const FAILED_TO_SEND_EMAIL_NOTIFICATION_MESSAGE = "Failed to send Email Notifcation"
export const JOB_TITLE_REQUIRED_MESSAGE = "Job Title is required."
export const JOB_CLASS_REQUIRED_MESSAGE = "Job Class is required."
export const DEPARTMENT_REQUIRED_MESSAGE = "Department is required."
export const REMARKS_REQUIRED_MESSAGE = "Remarks are required."

export const DEFAULT_EMPTY_NAME = "All";

export const EMPLOYEE_REQUEST_FORM = "Employee Request Form";
export const APPLICATION_FORM = "Application Form";
export const INTERVIEWS = "Interviews";
export const BACKGROUND_CHECK = "Background Check";
export const JOB_OFFER = "Job Offer";
export const ONBOARDING = "Onboarding";
export const ONBOARDING_TRAINING_TRACKER = "Onboarding Training Tracker";
export const MANCOM_REPORT = "ManCom Report";
export const SUMMARY_REPORT = "Summary Report";

export const DETAIL_APPLICANT_STATUSES = [
  'Pending',
  'On-hold',
  'For Screening',
  'Shortlisted',
  'For Preliminary Interview',
  'Rejected/Failed'
];

export const ONBOARDING_FIELDS = [
  { key: "TrainingCategory", label: "Training Category" },
  { key: "TrainingName", label: "Training Name" },
  { key: "OnboardingTypeName", label: "Type" },
  { key: "Schedule", label: "Schedule of Training" },
  { key: "Duration", label: "Duration" },
  { key: "FacilitatorName", label: "Facilitator" },
  { key: "OnboardingStatusName", label: "Status" }
]

export const ONBOARDING_TRACKER_FIELDS = [
  { key: "EmployeeName", label: "Employee Name" },
  { key: "EmployeeID", label: "Employee ID" },
  { key: "TrainingCategory", label: "Training Category" },
  { key: "TrainingName", label: "Training Name" },
  { key: "OnboardingType", label: "Onboarding Type" },
  { key: "OnboardingTrainingStatus", label: "Onboarding Training Status" }
]

export const DEFAULT_EMPTY_OPTION = {
    value: -1,
    name: 'All',
}

export const ADJUSTED_STATUS = (withEmpty = false, emptyOption = DEFAULT_EMPTY_OPTION) => {
    if (withEmpty) {
        const newEmptyOption = {
            ...DEFAULT_EMPTY_OPTION,
            ...emptyOption
        }
        return [
            newEmptyOption,
            { value: 0, name: 'No' },
            { value: 1, name: 'Yes' },
        ]
    }

    return [
        { value: 0, name: 'No' },
        { value: 1, name: 'Yes' },
    ]
}

export const APPROVED_STATUS = (withEmpty = false, emptyOption = DEFAULT_EMPTY_OPTION) => {
    if (withEmpty) {
        const newEmptyOption = {
            ...DEFAULT_EMPTY_OPTION,
            ...emptyOption
        }
        return [
            newEmptyOption,
            { value: 18, name: 'Approved' },
            { value: 19, name: 'Cancelled' },
            { value: 20, name: 'Pending' },
            { value: 21, name: 'Rejected' },
            { value: 22, name: 'Saved' },
        ]
    }

    return [
        { value: 18, name: 'Approved' },
        { value: 19, name: 'Cancelled' },
        { value: 20, name: 'Pending' },
        { value: 21, name: 'Rejected' },
        { value: 22, name: 'Saved' },
    ]
}

export const ADJUSTED_YES = '1'
export const ADJUSTED_NO = '0'

export const STATUS_PENDING = 'Pending'
export const STATUS_CANCELLED = 'Cancelled'
export const STATUS_DENIED = 'Denied'
export const STATUS_APPROVED = 'Approved'
export const STATUS_SAVED = 'Saved'
export const STATUS_REJECTED = 'Rejected'
export const TRACKER_STATUS_OPEN = 'Open'
export const TRACKER_STATUS_CLOSED = 'Closed'

export const LOAN_STATUS_PENDING_VALUE = 20
export const LOAN_STATUS_SAVED_VALUE = 22

export const MODULES = {
    ERF: 146,
}

export const Position = {
    HR: "Human Resources",
    MANAGER: "Managing Director",
}

export const STATUS_MAP = {
    '22': STATUS_SAVED,
    '21': STATUS_REJECTED,
    '20': STATUS_PENDING,
    '19': STATUS_CANCELLED,
    '18': STATUS_APPROVED,
    '87': TRACKER_STATUS_OPEN,
    '88': TRACKER_STATUS_CLOSED,
}

export const STATUS = {
    STATUS_SAVED: 22,
    STATUS_REJECTED: 21,
    STATUS_PENDING: 20,
    STATUS_CANCELLED: 19,
    STATUS_APPROVED: 18,
    TRACKER_STATUS_OPEN: 87,
    TRACKER_STATUS_CLOSED: 88,
}

export const BACKGROUND_CHECK_STATUS_MAP = {
    STATUS_PASS: 16,
    STATUS_FAIL: 18,
    STATUS_PENDING: 21
}

export const GROUPINGS = (withEmpty = false, label = 'None') => {
    if (withEmpty) {
        return [
            { value: 0, name: label },
            { value: 1, name: 'By Department' },
            { value: 2, name: 'By Section' },
        ]
    }

    return [
        { value: 1, name: 'By Department' },
        { value: 2, name: 'By Section' },
    ]
}

export const EMPLOYMENT_STATUS = (withEmpty = false, label = 'All') => {
    if (withEmpty) {
        return [
            { value: 0, name: label },
            { value: 10, name: 'Regular' },
            { value: 9, name: 'Probationary' },
            { value: 7, name: 'Contractual' },
            { value: 8, name: 'OJT' },
            { value: 11, name: 'Resigned' },
            { value: 12, name: 'Terminated' },
            { value: 6, name: 'AWOL' },
        ]
    }

    return [
        { value: 0, name: label },
        { value: 10, name: 'Regular' },
        { value: 9, name: 'Probationary' },
        { value: 7, name: 'Contractual' },
        { value: 8, name: 'OJT' },
        { value: 11, name: 'Resigned' },
        { value: 12, name: 'Terminated' },
        { value: 6, name: 'AWOL' },
    ]
}

export const EMPLOYMENT_STATUS2 = (withEmpty = false, label = 'All') => {
    if (withEmpty) {
        return [
            { value: 0, name: label },
            { value: 1, name: 'Regular' },
            { value: 2, name: 'Probationary' },
            { value: 3, name: 'Contractual' },
            { value: 4, name: 'OJT' },
            { value: 5, name: 'Casual' },
            { value: 6, name: 'Others 1' },
            { value: 7, name: 'Others 2' },
            { value: 8, name: 'Others 3' },
            { value: 9, name: 'Others 4' },
            { value: 10, name: 'Others 5' },
            { value: 11, name: 'Consultant' },
        ]
    }

    return [
        { value: 1, name: 'Regular' },
        { value: 2, name: 'Probationary' },
        { value: 3, name: 'Contractual' },
        { value: 4, name: 'OJT' },
        { value: 5, name: 'Casual' },
        { value: 6, name: 'Others 1' },
        { value: 7, name: 'Others 2' },
        { value: 8, name: 'Others 3' },
        { value: 9, name: 'Others 4' },
        { value: 10, name: 'Others 5' },
        { value: 11, name: 'Consultant' },
    ]
}

export const TERMINATION_STATUS = (withEmpty = false, label = 'All') => {
    if (withEmpty) {
        return [
            { value: -1, name: label },
            { value: 0, name: 'Active' },
            { value: 1, name: 'Resigned' },
            { value: 2, name: 'Terminated' },
            { value: 3, name: 'Retired' },
            { value: 4, name: 'Transferred' },
        ]
    }

    return [
        { value: 0, name: 'Active' },
        { value: 1, name: 'Resigned' },
        { value: 2, name: 'Terminated' },
        { value: 3, name: 'Retired' },
        { value: 4, name: 'Transferred' },
    ]
}

export const PAYROLL_SCHEDULE = (withEmpty = false, label = 'All') => {
    if (withEmpty) {
        return [
            { value: -1, name: label },
            { value: 0, name: 'Monthly' },
            { value: 1, name: 'Semi-Monthly' },
            { value: 2, name: 'Weekly' },
        ]
    }

    return [
        { value: 0, name: 'Monthly' },
        { value: 1, name: 'Semi-Monthly' },
        { value: 2, name: 'Weekly' },
    ]
}

export const CMP_SCHED_MONTLY = 0
export const CMP_SCHED_SEMI_MONTLY = 1
export const CMP_SCHED_WEEKLY = 2
export const CMP_SCHED_EMP_TERMINATION = 3
export const CMP_SCHED_BONUS = 4

export const COMPUTATION_SCHEDULE = (withEmpty = false, label = 'All') => {
    if (withEmpty) {
        return [
            { value: -1, name: label },
            { value: 0, name: 'Monthly' },
            { value: 1, name: 'Semi-Monthly' },
            { value: 2, name: 'Weekly' },
            { value: 3, name: 'Bonus' },
            { value: 4, name: 'Employment Termination' },
        ]
    }

    return [
        { value: 0, name: 'Monthly' },
        { value: 1, name: 'Semi-Monthly' },
        { value: 2, name: 'Weekly' },
        { value: 3, name: 'Bonus' },
        { value: 4, name: 'Employment Termination' },
    ]
}

export const FILE_TYPES = {
    'TEXT': 0,
    'CSV': 1,
    'XML': 2,
    'FORMATTEDTEXT': 3,
    'EMF': 4,
    'DBASE': 5,
    'POWERSOFT': 6,
    'XLSX': 7,
}

export const BONUS_TIMING = (withEmpty = false, label = 'All') => {
    if (withEmpty) {
        return [
            { value: -1, name: label },
            { value: 0, name: 'Mid Year' },
            { value: 1, name: 'Year End' },
            { value: 2, name: '13th Month' },
        ]
    }

    return [
        { value: 0, name: 'Mid Year' },
        { value: 1, name: 'Year End' },
        { value: 2, name: '13th Month' },
    ]
}

export const PAYROLL_TYPE = (withEmpty = false, label = 'All') => {
    if (withEmpty) {
        return [
            { value: -1, name: label },
            { value: 0, name: 'Batch' },
            { value: 1, name: 'Department' },
            { value: 2, name: 'Employee' },
            { value: 3, name: 'Company' },
        ]
    }

    return [
        { value: 0, name: 'Batch' },
        { value: 1, name: 'Department' },
        { value: 2, name: 'Employee' },
        { value: 3, name: 'Company' },
    ]
}

export const AMOUNT_TYPE = (withEmpty = false, label = 'All') => {
    if (withEmpty) {
        return [
            { value: -1, name: label },
            { value: 0, name: 'Basic Rate' },
            { value: 1, name: 'Basic Pay' },
            { value: 2, name: 'Gross Pay' },
        ]
    }

    return [
        { value: 0, name: 'Basic Rate' },
        { value: 1, name: 'Basic Pay' },
        { value: 2, name: 'Gross Pay' },
    ]
}

export const RATE_TYPE = (withEmpty = false, label = 'All') => {
    if (withEmpty) {
        return [
            { value: -1, name: label },
            { value: 19, name: 'Daily' },
            { value: 20, name: 'Monthly' },
            //{ value: 2, name: 'Hourly' },
            //{ value: 3, name: 'Based on Class' },
        ]
    }

    return [
        { value: 19, name: 'Daily' },
        { value: 20, name: 'Monthly' },
        //{ value: 2, name: 'Hourly' },
        //{ value: 3, name: 'Based on Class' },
    ]
}

export const DISTRIBUTE_FLAG = (withEmpty = false, label = 'All') => {
    if (withEmpty) {
        return [
            { value: -1, name: label },
            { value: 0, name: 'Beginning of Month' },
            { value: 1, name: 'Payroll' },
            { value: 2, name: 'End of the Month' },
        ]
    }

    return [
        { value: 0, name: 'Beginning of Month' },
        { value: 1, name: 'Payroll' },
        { value: 2, name: 'End of the Month' },
    ]
}

export const WRITEOFF_FLAG = (withEmpty = false, label = 'All') => {
    if (withEmpty) {
        return [
            { value: -1, name: label },
            { value: 0, name: 'No' },
            { value: 1, name: 'Yes' },
        ]
    }

    return [
        { value: 0, name: 'No' },
        { value: 1, name: 'Yes' },
    ]
}

export const ACTION_FLAG = (withEmpty = false, label = 'All') => {
    if (withEmpty) {
        return [
            { value: -1, name: label },
            { value: 0, name: 'Regularization' },
            { value: 1, name: 'Salary Adjustment' },
            { value: 2, name: 'Probationary' },
            { value: 3, name: 'Reclassification' },
            { value: 4, name: 'Transfer' },
            { value: 5, name: 'Others' },
        ]
    }

    return [
        { value: 0, name: 'Regularization' },
        { value: 1, name: 'Salary Adjustment' },
        { value: 2, name: 'Probationary' },
        { value: 3, name: 'Reclassification' },
        { value: 4, name: 'Transfer' },
        { value: 5, name: 'Others' },
    ]
}

export const REASON_FLAG = (withEmpty = false, label = 'All') => {
    if (withEmpty) {
        return [
            { value: -1, name: label },
            { value: 0, name: 'Annual Merit Increase' },
            { value: 1, name: 'Promotion or Upgrading' },
            { value: 2, name: 'Regularization' },
            { value: 3, name: 'Salary Standardization' },
            { value: 4, name: 'Others' },
        ]
    }

    return [
        { value: 0, name: 'Annual Merit Increase' },
        { value: 1, name: 'Promotion or Upgrading' },
        { value: 2, name: 'Regularization' },
        { value: 3, name: 'Salary Standardization' },
        { value: 4, name: 'Others' },
    ]
}

export const MERIT_FLAG = (withEmpty = false, label = 'All') => {
    if (withEmpty) {
        return [
            { value: -1, name: label },
            { value: 0, name: 'Outstanding' },
            { value: 1, name: 'Very Good' },
            { value: 2, name: 'Fully Acceptable' },
            { value: 3, name: 'Can Use Improvement' },
        ]
    }

    return [
        { value: 0, name: 'Outstanding' },
        { value: 1, name: 'Very Good' },
        { value: 2, name: 'Fully Acceptable' },
        { value: 3, name: 'Can Use Improvement' },
    ]
}

export const ANNUALIZE_TAX = (withEmpty = false, label = 'All') => {
    if (withEmpty) {
        return [
            { value: -1, name: label },
            { value: 0, name: 'None' },
            { value: 1, name: 'Salaries Only' },
            { value: 2, name: 'Salaries and Bonuses' },
        ]
    }

    return [
        { value: 0, name: 'None' },
        { value: 1, name: 'Salaries Only' },
        { value: 2, name: 'Salaries and Bonuses' },
    ]
}

export const JOB_CLASSIFICATION = (withEmpty = false, label = 'All') => {
    if (withEmpty) {
        return [
            { value: -1, name: label },
            { value: 0, name: 'Direct' },
            { value: 1, name: 'Indirect' },
            { value: 2, name: 'Exempt' },
            { value: 3, name: 'Non-Exempt' },
        ]
    }

    return [
        { value: 0, name: 'Direct' },
        { value: 1, name: 'Indirect' },
        { value: 2, name: 'Exempt' },
        { value: 3, name: 'Non-Exempt' },
    ]
}

export const SALARY_TYPE = (withEmpty = false, label = 'All') => {
    if (withEmpty) {
        return [
            { value: -1, name: label },
            { value: 17, name: 'Confidential' },
            { value: 18, name: 'Non-confidential' },
            //{ value: 2, name: 'Hourly' },
        ]
    }

    return [
        { value: 17, name: 'Confidential' },
        { value: 18, name: 'Non-confidential' },
        //{ value: 2, name: 'Hourly' },
    ]
}

export const JOB_ACCEPTANCE = (withEmpty = false, label = 'All') => {
    if (withEmpty) {
        return [
            { value: '', name: label },
            { value: 'Pending', name: 'Pending' },
            { value: 'Accepted', name: 'Accepted' },
            { value: 'Declined', name: 'Declined' },
        ]
    } else {
        return [ 
            { value: 'Pending', name: 'Pending' },
            { value: 'Accepted', name: 'Accepted' },
            { value: 'Declined', name: 'Declined' },
        ]
    }
}


export const Gender = (withEmpty = false, label = 'ALL') => {
    if (withEmpty) {
        return [
            { value: -1, name: label },
            { value: 1, name: 'Male' },
            { value: 0, name: 'Female' },
        ]
    }

    return [
        { value: 1, name: 'Male' },
        { value: 0, name: 'Female' },
    ]
}

export const ATKStamp = (withEmpty = false, label = 'ALL') => {
    if (withEmpty) {
        return [
            { value: -1, name: label },
            { value: 1, name: 'Required' },
            { value: 0, name: 'Not Required' },
        ]
    }

    return [
        { value: 1, name: 'Required' },
        { value: 0, name: 'Not Required' },
    ]
}
